import moment from 'moment';
import $ from "jquery";

$(document).ready(function() {
    var works = $('#works');
	var pickers = $('[data-choosedate]');
    var monthStatsCache = {}; // JSON.parse(sessionStorage.getItem('monthStatsCache') || '{}');

    function reloadPickerData(d) {
        if (monthStatsCache[`${d.year()}-${d.month() + 1}`] == null) {
            connection.getJson('/Work/MonthPickerOverview', {
                data: {
                    year: d.year(),
                    month: d.month() + 1,
                },
                onSuccess: function(data) {
                    var dp = $('.work-calendars');
                    $.each(data, function() {
                        var date = moment(this.Date);
                        if (!monthStatsCache[date.format("yyyy-MM")]) {
                            monthStatsCache[date.format("yyyy-MM")] = {};
                        }
                        var progress = Math.round((100 / 8) * parseFloat(this.Duration));
                        monthStatsCache[date.format("yyyy-MM")][date.format("DD")] = {
                            "Date": this.Date,
                            "Duration": this.Duration,
                            "Progress": progress,
                        };
                    });
                    sessionStorage.setItem('monthStatsCache', JSON.stringify(monthStatsCache));
                    applyStatsCache();
                },
            });
        } else {
            applyStatsCache();
        }
    }

    function applyStatsCache() {
        setTimeout(() => {
            var dp = $('.work-calendars');
            $.each(dp.find('td.day'), function(i, dayEl) {
                var $dayEl = $(dayEl);
                var d = moment(parseInt($dayEl.attr('data-date')));
                var data = null;
                if (`${d.year()}-${d.month() + 1}` in monthStatsCache) {
                    data = monthStatsCache[`${d.year()}-${d.month() + 1}`][d.format("DD")] || null;
                    if (data) {
                        $dayEl
                            .addClass('position-relative')
                            .attr('title', data.Duration + 'h')
                            .prepend($(`<div class="progress-indicator ${(data.Progress > 100 ? 'progress-dark' : 'progress-light')}"></div>`));
                    }
                }
            });
        }, 100);
    }

    $.each(pickers, (i, el) => {
        var picker = $(el);
        picker.datepicker({
            language: 'de',
            inline: picker.is('.calender-inline'),
            firstDay: 1,
            calendarWeeks: true,
            showOtherMonths: true,
            selectOtherMonths: true,
            todayBtn: true,
            todayHighlight: true,
            format: 'yyyy-mm-dd',
            beforeShowDay: function(date) {
                console.log('beforeShowDay');
                return { classes: 'd-' + date.getFullYear() + '-' + ((date.getMonth() + 1)+"").padStart(2, '0') + '-' + (date.getDate()+"").padStart(2, '0') };
            },
        });
        picker.on('changeMonth', function (ev) {
            console.log('changeMonth');
            var d = moment(ev.date);
            reloadPickerData(d);
        });
        picker.on('changeDate', function () {
            console.log('changeDate');
            var d = moment(picker.datepicker("getDate"));
            var data = JSON.parse(works.attr('data-loadParams'));
            data.Date = d.format('yy-MM-DD');
            works.attr('data-loadParams', JSON.stringify(data));
            connection.loadPart(works, function(table) {});

            history.pushState(null, null, location.pathname + '?day=' + data.Date);
            applyStatsCache();
        });

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('day')) {
            var date = moment(urlParams.get("day"));
            picker.datepicker("setDate", date.toDate());
        }
        reloadPickerData(moment(picker.datepicker("getDate")));
    });
});
$(document).on('content-ready', function(ev, container) {
    if (container.is('#works')) {
        initTableEvents(container);
        initSlideinButtons(container.find('[data-slidein]'));
    }
    workingtimers.init(container);

    if (container.find('.work-statistics').length === 1) {
        initWorkStatistics(container);
    }
});

var workingtimers = {
    init: function(container) {
        $.each(container.find('.timers .timer'), function(i, el) {
            workingtimers.initTimerEvents($(el));
        });

        var me = this;
        var startedTimer = container.find('[data-running=1]');
        $.each(startedTimer, function(i, el) {
            me.startTimer($(el), false);
        });
    },

    getLastUsedProjects: function(callback) {
        // if (localStorage.getItem('latest-objects') === null) {
            connection.getJson('/Work/LastUsedProjects', {
            }).then(response => {
                callback(response);
            });
        // } else {
        //     var response = JSON.parse(localStorage.getItem('latest-objects'));
        //     callback(response);
        // }
    },

    initTimerEvents: function(timerEl) {
        // registerDatePickers(timerEl.find('.ctl-datepicker'));
        // initAutocompleter(timerEl.find('.ctl-autocompleter'));
        workingtimers.updateTime(timerEl, timerEl.find('.total-duration').find("input").val());

        // timerEl.on('menu-rendered', (ev, data) => {
        //     workingtimers.getLastUsedProjects((response) => {
        //         workingtimers.appendLatestProjects(data, response);
        //     });
        // });

        timerEl.find('[data-timer=start]').click(function() {
            workingtimers.startTimer(timerEl, true);
            return false;
        });
        timerEl.find('[data-timer=stop]').click(function() {
            workingtimers.stopTimer();
            return false;
        });
        // timerEl.find('[data-timer=append]').click(function() {
        //     workingtimers.addTime(timerEl);
        // });
        // timerEl.find('[data-timer=subtract]').click(function() {
        //     workingtimers.addTime(timerEl, true);
        // });
        // timerEl.find('[data-timer=reset]').click(function() {
        //     workingtimers.resetTime(timerEl);
        // });

        // timerEl.find('[data-expense-currency]').click(function() {
        //     var row = $(this).closest('[data-workid]');
        //     row.find('[data-expense-currency]').removeClass('active');
        //     $(this).addClass('active');
        //     workingtimers.storeWorkData(row, 'ExpenseCurrency', row.attr('data-expense-currency'), () => {
        //     });
        // });
        // timerEl.find('[name="Notice"],[name="Expenses"],[name="DriveDistance"]').blur(function() {
        //     var row = $(this).closest('[data-workid]');
        //     workingtimers.storeWorkData(row, $(this).attr('name'), $(this).val(), () => {
        //         // row.find('[data-project-value]').text(item.label);
        //     });
        // });
    },

    appendLatestProjects: function(data, response) {
        if (data.ul.find('[data-title]').length === 0) {
            var li = $('<li class="ui-menu-item bg-lightgray ui-state-disabled ui-menu-title" disabled="disabled">')
                .append($('<div class="dd-option py-1 ui-menu-item-wrapper">').html('<b>Projekte</b>'))
                .prependTo(data.ul);
            li.data("ui-autocomplete-item", {value: "", disabled: true});

            if (response.length > 0) {
                $.each(response, function (index, item) {
                    var li = $('<li class="ui-menu-item">')
                        .append($('<a class="dd-option ui-menu-item-wrapper">').text(item.label))
                        .prependTo(data.ul);
                    li.data("ui-autocomplete-item", item);
                    li.click(ev => {
                        if ($('.timers tr[data-project-id="'+item.value+'"]').length === 0) {
                            workingtimers.addRapportRow(item.value);
                        }
                    });
                });

                var li2 = $('<li class="ui-menu-item bg-lightgray ui-state-disabled ui-menu-title" disabled="disabled">')
                    .append($('<div class="dd-option py-1 ui-state-disabled ui-menu-item-wrapper">').html('<b>Zuletzt verwendet</b>'))
                    .prependTo(data.ul);
                li2.data("ui-autocomplete-item", {value: "", disabled: true});
            }
            localStorage.setItem('latest-objects', JSON.stringify(response));
        }
    },

    // storeWorkData: function(row, fieldName, value, callback) {
    //     connection.getJson('/Work/SaveStartedWorkField', {
    //         data: {
    //             id: row.attr('data-workid'),
    //             field: fieldName,
    //             value: value,
    //         },
    //         onSuccess: function(response) {
    //             if (callback) callback();
    //         },
    //     });
    // },

    startTimer: function(sourceTimerEl, stopRunningTimer) {
        if (stopRunningTimer) {
            connection.getJson('/Work/StopAllTimersOfUser', {
                onSuccess: response => {
                    workingtimers.startTimer(sourceTimerEl, false);
                },
            });
        }
        //
        var timerEl = sourceTimerEl;
        // var projectEl = timerEl.closest('[data-project-id]');
        var isRunning = timerEl.is('[data-running=1]');
        var durationEl = $(timerEl.find('[name=Durations]'));
        var counterEl = $(timerEl.find('[data-time]'));
        var startTime = (isRunning) ? moment(timerEl.attr('data-start') * 1000) : moment();
        var existingTime = timerEl.find('.total-duration').find("input").val().split(":");
        if (existingTime.length > 0) {
            startTime = startTime.add(existingTime[0] * -1, 'hours');
            startTime = startTime.add(existingTime[1] * -1, 'minutes');
        }
        console.log(startTime, startTime.unix(), new Date(startTime.unix() * 1000));
        counterEl.countdown({
            date : new Date(startTime.unix() * 1000),
            direction: 'up',
            htmlTemplate: '%hh %im',
            leadingZero: true,
            minus: true,
            stopwatch: true,
            onChange: function() {
                durationEl.val(counterEl.html());
            },
            onComplete: function( event ) {
            }
        });
        if (!isRunning) {
            connection.getJson('/Work/StartStartedWork', {
                data: {
                    id: timerEl.attr('data-id'),
                    // day: timerEl.attr('data-day'),
                    // rapportTypeId: projectEl.attr('data-rapporttype-id'),
                    // projectId: projectEl.attr('data-project-id'),
                },
                onSuccess: response => {
                    timerEl.attr('data-id', response.Id);
                    timerEl.attr('data-running', 1);
                },
            });
        }
    },

    stopTimer: function(onSuccess) {
        $.each($('[data-running=1]'), function() {
            var timerEl = $(this);
            if (timerEl.is('[data-running=1]')) {
                connection.getJson('/Work/StopStartedWork', {
                    data: {
                        id: timerEl.attr('data-id'),
                    },
                    onSuccess: response => {
                        $(timerEl.find('[data-time]')).countdown("pause");
                        timerEl.attr('data-running', 0);
                        workingtimers.updateTime(timerEl, response.TotalDuration, response.TotalDurationDecimal);

                        if (onSuccess) onSuccess();
                    },
                });
            }
        });
    },

    updateTime: function(timerEl, totalDuration, totalDurationDecimal) {
        timerEl.find('.total-duration').find("input").val(totalDuration);
        var times = totalDuration.split(":");
        timerEl.find('[data-time]').text(`-`);
        if (times.length >= 2) {
            if (parseInt(times[0]) > 0) {
                timerEl.find('[data-time]').text(`${times[0]}:${times[1]}`);
            } else {
                timerEl.find('[data-time]').text(`0:${times[1]}`);
            }
        }

        if (totalDurationDecimal) {
            var dayEl = timerEl.closest('[data-day]');
            var projectRow = timerEl.closest('tr');
            dayEl.attr('data-decimal', totalDurationDecimal);

            var sum = $(`[data-day="${dayEl.attr('data-day')}"]`).toArray().reduce(function (sum, element) {
                if (isNaN(sum)) sum = 0;
                return sum + Number($(element).attr('data-decimal'));
            }, 0);
            $(`[data-day-total="${dayEl.attr('data-day')}"]`).text(sum.decimalToTime());

            var rowSum = $(`[data-day]`).toArray().reduce(function (rowSum, element) {
                if (isNaN(rowSum)) rowSum = 0;
                return rowSum + Number($(element).attr('data-decimal'));
            }, 0);
            if (projectRow.attr('data-project-id')) {
                $(`[data-project-total="${projectRow.attr('data-project-id')}"]`).text(rowSum.decimalToTime());
            } else {
                $(`[data-rapporttype-total="${projectRow.attr('data-rapporttype-id')}"]`).text(rowSum.decimalToTime());
            }
        }
    },

    // resetTime: function(timerEl) {
    //     if (timerEl.is('[data-running=1]')) return;
    //
    //     timerEl.startProcess();
    //     var projectRow = timerEl.closest('[data-rapporttype-id]');
    //     connection.getJson('/Work/ResetTimeOf', {
    //         data: {
    //             id: timerEl.attr('data-workid'),
    //             day: timerEl.attr('data-day'),
    //             rapportTypeId: projectRow.attr('data-rapporttype-id'),
    //             projectId: projectRow.attr('data-project-id'),
    //         },
    //         onComplete: () => {
    //             timerEl.endProcess();
    //         },
    //         onSuccess: response => {
    //             timerEl.attr('data-workid', response.Id);
    //             timerEl.find('[name=DurationHours]').val('');
    //             timerEl.find('[name=DurationMinutes]').val('');
    //             workingtimers.updateTime(timerEl, response.TotalDuration, response.TotalDurationDecimal);
    //         },
    //     });
    // },

    // addTime: function(timerEl, subtractTime) {
    //     if (timerEl.is('[data-running=1]')) return;
    //
    //     timerEl.startProcess();
    //     var projectRow = timerEl.closest('[data-rapporttype-id]');
    //     connection.getJson('/Work/AppendTimeToStartedWork', {
    //         data: {
    //             id: timerEl.attr('data-workid'),
    //             day: timerEl.attr('data-day'),
    //             rapportTypeId: projectRow.attr('data-rapporttype-id'),
    //             projectId: projectRow.attr('data-project-id'),
    //             duration: (subtractTime === true ? '-' : '')+(timerEl.find('[name=DurationHours]').val()||'0')+":"+(timerEl.find('[name=DurationMinutes]').val()||'0'),
    //             expenses: timerEl.find('[name=Expenses]').val(),
    //             expenseCurrency: timerEl.find('[name=ExpenseCurrency]').val(),
    //             driveDistance: timerEl.find('[name=DriveDistance]').val(),
    //         },
    //         onComplete: () => {
    //             timerEl.endProcess();
    //         },
    //         onSuccess: response => {
    //             timerEl.attr('data-workid', response.Id);
    //             timerEl.find('[name=DurationHours]').val('');
    //             timerEl.find('[name=DurationMinutes]').val('');
    //             workingtimers.updateTime(timerEl, response.TotalDuration, response.TotalDurationDecimal);
    //         },
    //     });
    // },

    addRapportRow: function(projectId, rapportTypeId) {
        var table = $('table.timers');
        table.startProcess();
        connection.getJson('/Work/DailyWorksTableRow', {
            data: {
                rapportTypeId: rapportTypeId,
                projectId: projectId,
                dayStart: table.find('thead [data-day]').first().attr('data-day'),
                days: table.find('thead [data-day]').length,
            },
            onComplete: () => {
                table.endProcess();
            },
            onSuccess: (response) => {
                var newRow = $(response.html);
                table.find('tbody').append(newRow);
                $.each(newRow.find('.timer-container'), function(i, el) {
                    workingtimers.initTimerEvents($(el));
                });
                onContentReady(newRow);
            },
        });
    },

    deleteRapport: function(timerEl) {
        messaging.askYesNo('Eintrag löschen', 'Willst du die rapportierte Zeit wirklich löschen?', function () {
            var url = '/Work/Delete/' + timerEl.attr('data-workid');
            connection.loadJson(url, null, function () {
                timerEl.attr('data-workid', '');
                timerEl.attr('data-running', '0');
                timerEl.find('[data-time]').val('-');
                messaging.showGlobalMessage('success', null, 'Der Eintrag wurde gelöscht.');
            });
        });
    },
};
window.workingtimers = workingtimers;

function initTableEvents(table) {
    $.each(table.find('[data-dropdown="project"]'), (i, el) => {
        $(el).parent().on('show.bs.dropdown', (ev) => {
            console.log('show.bs.dropdown');
            var field = $(ev.currentTarget).find('[name="ProjectId"]');
            var latestList = field.closest('.dropdown-menu').find('.dropdown-latest-items ul');
            initAutocompleter(field);
            field.off('changed').on('changed', (ev, data) => {
                if (table.find('tr[data-project-id="'+data.value+'"]').length === 0) {
                    workingtimers.addRapportRow(data.value, 1);
                }
            });
            field.on('menu-rendered', (ev, data) => {
                latestList.toggleClass('d-none', data.autocompleter.term.trim() !== '');
            });
        });
        $(el).parent().on('shown.bs.dropdown', (ev) => {
            console.log('shown.bs.dropdown');
            var field = $(ev.currentTarget).find('[name="ProjectId"]');
            field.next().val('').focus();
            var latestList = field.closest('.dropdown-menu').find('.dropdown-latest-items ul');
            latestList.empty();
            workingtimers.getLastUsedProjects((response) => {
                workingtimers.appendLatestProjects({
                    ul: latestList,
                }, response);
                latestList.removeClass('d-none');
            });
        });
    });

    // $.each(table.find('[data-dropdown="time"]'), (i, el) => {
    //     $(el).parent().on('show.bs.dropdown', (ev) => {
    //         var dropdown = $(ev.currentTarget);
    //         dropdown.find('[name="DurationHours"]').val('');
    //         dropdown.find('[name="DurationMinutes"]').val('');
    //
    //         dropdown.find('[name="DurationHours"]').on('keyup', ev => {
    //             const isNumber = isFinite(event.key);
    //             if (isNumber) {
    //                 var val = $(ev.currentTarget).val();
    //                 if (val.length >= 2) {
    //                     dropdown.find('[name="DurationMinutes"]').focus();
    //                 }
    //             }
    //         });
    //     });
    // });

    table.find('[data-rapporttype-add]').click(ev => {
        var me = $(ev.currentTarget);
        if (table.find('tr[data-rapporttype-id="'+me.attr('data-rapporttype-add')+'"]').length === 0) {
            workingtimers.addRapportRow(null, me.attr('data-rapporttype-add'));
        }
    });

	var deleteLinks = table.find('[data-delete]');
	deleteLinks.bind('click', function () {
		var timerEl = $(this).closest('[data-workid]');
        workingtimers.deleteRapport(timerEl);
		return false;
	});
}

function initWorkStatistics(container) {
    var body = $('body');
    var statisticsFilterForm = $('.statistics-filter');

    body.on('daterangepicker.changed', function (ev, picker) {
        statisticsFilterForm.submit();
    });

    var projectIdFilter = body.find('#ProjectId');
    projectIdFilter.on('changed', ev => {
        statisticsFilterForm.submit();
    });
}
